
import * as React from 'react';
import { compose, setDisplayName } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { Select } from 'ui/shared/Select';

export type OwnProps = {
    id: string;
    value: string;
    onChange: React.ChangeEventHandler<HTMLSelectElement>;
    disabled: boolean;
};

const RawDayPicker = ({ id, value, onChange, disabled, t }: OwnProps & TranslateProps) =>
    <Select
        id={ id }
        value={ value }
        onChange={ onChange }
        disabled={ disabled }
    >
        <option value="Sunday">{ t('385') }</option>
        <option value="Monday">{ t('379') }</option>
        <option value="Tuesday">{ t('380') }</option>
        <option value="Wednesday">{ t('381') }</option>
        <option value="Thursday">{ t('382') }</option>
        <option value="Friday">{ t('383') }</option>
        <option value="Saturday">{ t('384') }</option>
    </Select>
;

export const DayPicker = compose<OwnProps & TranslateProps, OwnProps>(
    setDisplayName('DayPicker'),
    translate(),
)(RawDayPicker);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/schedule/runOnSchedule/recurrence/DayPicker.tsx